import { useQuery } from '@tanstack/react-query';
import { DataService } from '@/services/dataService';
import { queryKeys } from './queryKeys';

export function useSettingsQuery(enabled: boolean) {
    return useQuery({
        queryKey: queryKeys.settings,
        queryFn: () => DataService.getSettings(),
        enabled,
        select: (data) => data ?? undefined,
        staleTime: 0, // Siempre refetch al montar/focus para que los paquetes guardados se vean tras recargar
    });
}
